/**
 * Constants for the Occurrence Report Descriptor Editor
 */

/**
 * Maximum length for text input fields
 */
export const MAX_TEXT_LENGTH = 255;

/**
 * Required terms that cannot be removed from the descriptor
 * (Empty array - no terms are required by default)
 */
export const REQUIRED_TERMS = [] as const;

/**
 * States for occurrence report descriptors
 */
export enum DescriptorState {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED'
}

/**
 * Regular expression for validating URIs
 */
export const URI_REGEX = /^https?:\/\/[^\s/$.?#].[^\s]*$/;

/**
 * Default term entries for new descriptors
 * Start with one empty entry to guide users
 */
export const DEFAULT_TERM_ENTRIES = [
    {
        key: { text: '', error: false },
        value: { text: '', error: false }
    }
];

/**
 * Error messages for validation
 */
export const ERROR_MESSAGES = {
    NAME_REQUIRED: 'Name is required',
    DESCRIPTION_REQUIRED: 'Description is required',
    URI_INVALID: 'URI not valid',
    TERM_KEY_EMPTY: 'Key cannot be empty',
    TERM_KEY_EXISTS: 'Key already exists',
    TERM_VALUE_REQUIRED: (key: string) => `${key} value cannot be blank`
} as const;